<template>
    <div style="position: relative" class="configuration-button-container">
        <div
            class="configuration-buttons"
            :class="{'cancel-configuration': configurationExist}"
            @mouseover="onMouseOver"
            @mouseout="onMouseLeaveOver"
        >
            <component
                :is="subscribeButtonToDisplay"
                :parent="himself"
            ></component>
        </div>
        <div class="button-label" :class="btnClass">{{ btnText }}</div>
    </div>
</template>

<script>

import SubscribePlayBtn from './play-btn.vue';
import SubscribeAddBtn from './add-btn.vue';
import SubscribeCancelBtn from './cancel-btn.vue';
import SubscribeStopBtn from './stop-btn.vue';
import SubscribeLoadingBtn from './loading-btn.vue';
import ErrorBtn from './error-btn.vue';
import SubscribeCheckBtn from './check-btn.vue';
import SubscribeStartingBtn from './starting-btn.vue';
import SubscribeEndLoadingBtn from './end-loading-btn.vue';
import moment from 'moment';
export default {

    components: {
    },

    props: {
        channel: {
            type: Object,
            required: true
        },
        configuration: {
            required: true,
            validator: prop => typeof prop === 'object' || prop === null
        },
    },

    data: function(){
        return {
            loading: true,
            hover: false,
            cancelPopoverOpened: false,
            now: new Date(),
            timeoutID: null,
            hoverHandler: null,
        };
    },
    computed: {
        cancelling (){
            if(this.cancelPopoverOpened||this.hover){
                return true;
            }else{
                return false;
            }
        },

        verboseStateBtn (){
            if(this.channel.status === 'FAILED'){
                return 'error-btn';
            }else if(this.configurationExist && ['CONNECTING','STARTING'].includes(this.configuration.status)){
                return 'subscribe-loading-btn';
            }else if(this.configurationExist && this.configuration.status === 'START_REQUESTED'){
                return 'subscribe-loading-btn';
            }else if(this.channel.status === 'STARTING' || this.channel.status === 'PREPARING'){
                if(this.configurationExist && this.cancelling){
                    return 'subscribe-cancel-btn';
                }else if(!this.configurationExist && this.hover){
                    return 'subscribe-add-btn';
                }
                return 'subscribe-starting-btn';
            }else if (!this.configurationExist){
                if (this.configuration !== null) {
                    if(this.configuration.status === 'FINISHING' || this.configuration.status === 'CONNECTED' || this.configuration.status === 'STOPPED'){
                        return 'subscribe-end-loading-btn';
                    } // case where the configuration is finished but still CONNECTED or FINISHING
                }
                return 'subscribe-add-btn';
            }
            else if(this.configurationExist && ['STOP_REQUESTED','STOPPING'].includes(this.configuration.status)){
                return 'subscribe-end-loading-btn';
            }
            else if(this.channel.status === 'AVAILABLE' || this.configuration.status === 'STOPPED'){
                if(this.cancelling){
                    return 'subscribe-cancel-btn';
                }else{
                    return 'subscribe-check-btn';
                }
            }else if (['PENDING'].includes(this.configuration.status)){
                return 'subscribe-loading-btn';
            }else if(this.channel.status === 'RUNNING'){
                if(this.cancelling){
                    return 'subscribe-stop-btn';
                }else{
                    return 'subscribe-play-btn';
                }
            }
            return 'subscribe-check-btn';
        },


        subscribeButtonToDisplay (){
            if(this.verboseStateBtn === 'error-btn'){
                return ErrorBtn;
            }else if(this.verboseStateBtn === 'subscribe-cancel-btn'){
                return SubscribeCancelBtn;
            }else if(this.verboseStateBtn === 'subscribe-add-btn'){
                return SubscribeAddBtn;
            }else if(this.verboseStateBtn === 'subscribe-loading-btn'){
                return SubscribeLoadingBtn;
            }else if(this.verboseStateBtn === 'subscribe-starting-btn'){
                return SubscribeStartingBtn;
            }else if(this.verboseStateBtn === 'subscribe-check-btn'){
                return SubscribeCheckBtn;
            }else if(this.verboseStateBtn === 'subscribe-stop-btn'){
                return SubscribeStopBtn;
            }else if(this.verboseStateBtn === 'subscribe-play-btn'){
                return SubscribePlayBtn;
            }else if (this.verboseStateBtn === 'subscribe-end-loading-btn'){ // end of a configuration
                return SubscribeEndLoadingBtn
            }
        },
        btnClass (){
            if(this.verboseStateBtn === 'error-btn'){
                return 'yellow';
            }else if(
                this.verboseStateBtn === 'subscribe-cancel-btn' ||
                this.verboseStateBtn === 'subscribe-stop-btn'
            ){
                return 'red';
            }else if(this.verboseStateBtn === 'subscribe-add-btn'){
                return 'blue';
            }else if(
                this.verboseStateBtn === 'subscribe-loading-btn' ||
                this.verboseStateBtn === 'subscribe-starting-btn' ||
                this.verboseStateBtn === 'subscribe-check-btn' ||
                this.verboseStateBtn === 'subscribe-end-loading-btn' // end of a configuration
            ){
                return 'grey';
            }else if(this.verboseStateBtn === 'subscribe-play-btn'){
                return 'green';
            }
        },
        btnText (){
            if(this.verboseStateBtn === 'error-btn'){
                return 'error';
            }else if(this.verboseStateBtn === 'subscribe-cancel-btn'){
                return 'cancel';
            }else if(this.verboseStateBtn === 'subscribe-add-btn'){
                return 'configure';
            }else if(this.verboseStateBtn === 'subscribe-loading-btn'){
                if(this.configuration.status === 'START_REQUESTED' || this.configuration.status === 'STARTING'){
                    return 'starting';
                }
                return 'connecting';
            }else if(this.verboseStateBtn === 'subscribe-starting-btn'){
                return 'starting';
            }else if(this.verboseStateBtn === 'subscribe-check-btn'){
                if(this.configuration.status === 'STOPPED'){
                    return 'stopped';
                }
                return 'configured';
            }else if(this.verboseStateBtn === 'subscribe-stop-btn'){
                return 'stop';
            }else if(this.verboseStateBtn === 'subscribe-play-btn'){
                return 'running';
            }else if(this.verboseStateBtn === 'subscribe-end-loading-btn'){ // end of a configuration
                if(['STOP_REQUESTED','STOPPING'].includes(this.configuration.status)){
                    return 'stopping';
                }
                return 'disconnecting';
            }
        },
        configurationExist() {
            return this.configuration !== null && !this.configuration.finished;
        },
        himself (){
            return this;
        },
        getTimeBeforeFeedStart (){
            let remainingMinutes = moment(this.channel.confirmed_start_date).diff(moment(this.now), 'minutes');
            if(remainingMinutes <= 0){
                remainingMinutes = '<1';
            }
            return remainingMinutes;
        },
    },
    mounted (){
        this.updateNow();
    },
    beforeDestroy (){
        clearTimeout(this.timeoutID);
    },

    methods: {
        onMouseOver (){
            this.hover = true;
            clearTimeout(this.hoverHandler);
            this.hoverHandler = setTimeout(() => {
                this.hover = false;
            }, 2000);
        },
        onMouseLeaveOver (){
            this.hover = false;
        },
        updateNow (){
            this.timeoutID = setTimeout(() => {
                this.now = new Date();
                this.updateNow();
            }, 5000);

        },
        onCancelling (){
            this.cancelPopoverOpened = true;
        },
        finallyNoCancel (){
            this.cancelPopoverOpened = false;
        },
        onAddConfiguration (){
            this.$emit('create-configuration');
        },
        cancelConfiguration() {
            let item = {
                uid: this.configuration.uid,
                url: this.configuration.url,
                end_date: moment().format,
            };
            if(this.channel.status === 'RUNNING' || this.channel.status === 'STARTING' || this.configuration.status === 'STOPPED'){
                item.finished = true;
            }else{
                item.cancelled = true;
            }

            this.$store.dispatch('patchItem', {
                item: item,
                model: 'configurations',
            }).then(() => {
                this.$emit('on-configuration-cancelled');
                this.$store.dispatch('fetchModelByName', 'configurations');
                this.$message({
                    message: `Configuration ${this.channel.status === 'RUNNING' ? 'stopped' : 'cancelled'}`,
                    type: 'success'
                });
                this.cancelPopoverOpened = false;
            }).catch(() => {
                this.$message.error('Fail on configuration cancelling');
            });
        },

        hideUnsubscribePopover() {
            if (this.$refs['unsubscribe-popover']) {
                this.$refs['unsubscribe-popover'].showPopper = false;
            }
        },
        hideSubscribePopover() {
            if (this.$refs['subscribe-popover']) {
                this.$refs['subscribe-popover'].showPopper = false;
            }
        },
    },
};
</script>

<style lang="scss">
.dark-popper {
    border: none !important;
    background-color: #444444 !important;
    color: #BBBBBB !important;
    padding: 0 !important;
    font-weight: 500 !important;
    font-family: "Roboto Regular";
    word-break: break-word;
    .popper__arrow, .popper__arrow::after {
        border-bottom-color: #444444 !important;
    }
    .popover-title {
        margin-top: 10px;
        text-align: center;
        padding: 0;
        font-size: 9px !important;
        border: none;
        background-color: #444444;
        text-transform: uppercase;
    }
    .actions {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        margin: 5px 11px 10px 0 !important;
        .decline, .accept {
            height: 18px;
            width: 24px;
            font-size: 9px !important;
            padding: 0;
            border-radius: 2px !important;
        }
        .decline {
            background-color: #444444;
            color: #BBBBBB;
        }
        .accept {
            background-color: #BBBBBB;
            color: #444444;
            &:hover {
                background-color: #00A3FF;
                color: #444444;
            }
        }
    }
}
.configuration-button-container{
    display: flex;
    flex-direction: column;
    align-items: center;
}
.button-label, .hover-action {
    position: relative;
    text-align: center;
    margin-top: 10px;
    text-transform: uppercase;
    font-size: 9px;
    z-index: 3;
    &.grey {
        color: #BBBBBB;
    }
    &.yellow {
        color: #FFDC42;
    }
    &.green {
        color: #28E37C;
    }
    &.red {
        color: #EF313C;
    }
    &.blue {
        color: #00A3FF;
    }
    &.disable-idle {
        display: none;
    }
}
.configuration-buttons {
    position: relative;
    &:hover {
        .hover-action {
            display: block;
        }
        .button-label.disable-idle {
            display: block;
        }
    }

    .hover-action {
        display: none;
        z-index: 4;
    }
    .unsubscribed {
        border-radius: 80px;
        .configuration-button-label {
            color: #EF313C;
        }
        &:hover {
            .configuration-button-label {
                display: block;
            }
        }
    }
    .running {
        .configuration-button-label {
            color: #00ECBF;
        }
    }
    .subscribed {
        border-radius: 80px;
        .configuration-button-label {
            color: #00A3FF;
        }
        &:hover {
            .configuration-button-label {
                display: block;
            }
        }
    }
    .configuration-button-label {
        position: absolute;
        left: 0;
        right: 0;
        text-align: center;
        margin-top: 10px;
        text-transform: uppercase;
        font-size: 9px;
        z-index: 3;
        display: none;
        &.display {
            display: block;
        }
    }
    .running-status {
        height: 50px;
        width: 50px;
        color: #00ECBF;
        border: 1px solid #00ECBF;
        border-radius: 80px;
        position: relative;
        img {
            position: absolute;
            top: 50%;
            left: 55%;
            transform: translate(-50%, -50%);
        }
    }
    .scheduled-status {
        height: 50px;
        width: 50px;
        color: #BBBBBB;
        border: 1px solid #BBBBBB;
        border-radius: 80px;
        position: relative;
        i {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
        }
    }
    .error-status {
        height: 50px;
        width: 50px;
        border: 1px solid #FFDC42;
        border-radius: 80px;
        position: relative;
        img {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
        }
    }
    .el-button {
        border-radius: 80px;
        font-size: 30px;
        height: 50px;
        width: 50px;
    }
    .subscribe-button {
        color: #00A3FF;
        border: 1px solid #00A3FF;
        &:hover, &:focus, &:active {
            background-color: #00A3FF !important;
            color: white !important;
        }
    }
    .stop-button {
        color: #EF315F;
        border: 1px solid #EF315F;
        position: relative;
        &:hover, &:focus, &:active {
            background-color: #EF315F !important;
            color: white !important;
        }
        &:after{
            content: '';
            position: absolute;
            height: 35px;
            width: 35px;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            border: 3px solid #000;
            border-radius: 5px;
        }
    }

    .unsubscribe-button {
        color: #EF315F;
        border: 1px solid #EF315F;
        &:hover, &:focus, &:active {
            background-color: #EF315F !important;
            color: white !important;
        }
    }
.subscribe-loading {
        position: relative;
        z-index: 1;
        display: block;
        height: 50px;
        width: 50px;
        border-radius: 50%;
        .image-container {
            z-index: 2;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 90%;
            height: 90%;
            border-radius: 50%;
            background-color: #222223;
            img {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                width: 30px;
                height: auto;
            }
        }
        .border {
            width: 100%;
            height: 100%;
            animation: rotate 2s linear infinite;
            background-color: #222223;
            &:after, &:before {
                content: '';
                position: absolute;
                top: 0;
                left: 0;
                z-index: 1;
                width: 100%;
                height: 50%;
            }
            // First half (top) of the cirlce with a left to right gradient
            &:before {
                border-radius: 200px 200px 0 0;
                background-image: linear-gradient(to right, #222223, #BBBBBB);
            }

            // Second half (bottom)
            &:after {
                top: 50%;
                border-radius: 0 0 200px 200px;
                background-image: linear-gradient(to right, #BBBBBB, #222223);
            }
        }

    }
}
@keyframes rotate {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}
</style>



// WEBPACK FOOTER //
// src/components/page/Channels/configurationButton/index.vue